import { render, staticRenderFns } from "./ScheduledCalendar.vue?vue&type=template&id=5454af1c&"
import script from "./ScheduledCalendar.vue?vue&type=script&lang=js&"
export * from "./ScheduledCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports